import React, { Component } from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import { ISO_DATE_FORMAT } from 'Global/constants'

const defaultState = {
  form: {
    advisor: [],
    availability: 'all',
    color: [],
    dateIndexed: {
      max: '',
      min: '',
    },
    dateInvoice: {
      max: '',
      min: '',
    },
    datePrimaryPicture: {
      max: '',
      min: '',
    },
    dateReceipt: {
      max: '',
      min: '',
    },
    dateReservation: {
      max: '',
      min: '',
    },
    description: '',
    report: false,
    requested: 'all',
    reservationEvent: [],
    reservationUser: [],
    sizeQm: {
      max: '',
      min: '',
    },
    source: [],
  },
}

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'ExtendedSearchModalContainer'

    static propTypes = {
      advisorOptions: PropTypes.array.isRequired,
      applyFilters: PropTypes.func.isRequired,
      applyExtendedFilters: PropTypes.func.isRequired,
      extendedFilters: PropTypes.object.isRequired,
      open: PropTypes.bool.isRequired,
      reservationEventOptions: PropTypes.array.isRequired,
      reservationUserOptions: PropTypes.array.isRequired,
      resetExtendedFilters: PropTypes.func.isRequired,
      toggle: PropTypes.func.isRequired,
    }

    state = {
      errors: {
        dateReservation: false,
      },
      form: this.props.extendedFilters,
    }

    handleAdvisor = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          advisor: value,
        },
      })
    }

    handleAvailability = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          availability: value,
          dateReservation: {
            max: '',
            min: '',
          },
        },
      })
    }

    handleIsMasterpiece = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          isMasterpiece: value,
        },
      })
    }

    handleDateReceiptMax = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          dateReceipt: {
            max: value,
            min: form.dateReceipt.min,
          },
        },
      })
    }

    handleDateReceiptMin = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          dateReceipt: {
            max: form.dateReceipt.max,
            min: value,
          },
        },
      })
    }

    handleDateReservationMax = date => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          dateReservation: {
            max: date ? moment(date).format(ISO_DATE_FORMAT) : '',
            min: form.dateReservation.min,
          },
        },
      })
    }

    handleDateReservationMin = date => {
      const { errors, form } = this.state

      this.setState({ errors: { ...errors, dateReservation: false } })

      this.setState({
        form: {
          ...form,
          dateReservation: {
            max: '',
            min: date ? moment(date).format(ISO_DATE_FORMAT) : '',
          },
        },
      })
    }

    handleDescription = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          description: value,
        },
      })
    }

    handleReport = (e, { checked }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          report: checked,
        },
      })
    }

    handleRequested = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          requested: value,
        },
      })
    }

    handleReservationEvent = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          reservationEvent: value,
        },
      })
    }

    handleReservationUser = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          reservationUser: value,
        },
      })
    }

    handleReset = e => {
      const { resetExtendedFilters, toggle } = this.props

      e.preventDefault()
      resetExtendedFilters()
      this.setState(defaultState)
      toggle()
    }

    handleSizeQmMax = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          sizeQm: {
            max: value,
            min: form.sizeQm.min,
          },
        },
      })
    }

    handleSizeQmMin = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          sizeQm: {
            max: form.sizeQm.max,
            min: value,
          },
        },
      })
    }

    handleSource = (e, { value }) => {
      const { form } = this.state

      this.setState({
        form: {
          ...form,
          source: value,
        },
      })
    }

    handleSubmit = e => {
      const { applyFilters, applyExtendedFilters, toggle } = this.props
      const { errors, form } = this.state

      e.preventDefault()

      if (!form.dateReservation.min && form.availability === 'customPeriod') {
        this.setState({ errors: { ...errors, dateReservation: true } })
      } else {
        applyFilters()
        applyExtendedFilters(form)
        toggle()
      }
    }

    render() {
      const { errors, form } = this.state

      return (
        <WrappedComponent
          errors={errors}
          form={form}
          handleAdvisor={this.handleAdvisor}
          handleAvailability={this.handleAvailability}
          handleDateReceiptMax={this.handleDateReceiptMax}
          handleDateReceiptMin={this.handleDateReceiptMin}
          handleDateReservationMax={this.handleDateReservationMax}
          handleDateReservationMin={this.handleDateReservationMin}
          handleDescription={this.handleDescription}
          handleIsMasterpiece={this.handleIsMasterpiece}
          handleReport={this.handleReport}
          handleRequested={this.handleRequested}
          handleReservationEvent={this.handleReservationEvent}
          handleReservationUser={this.handleReservationUser}
          handleReset={this.handleReset}
          handleSizeQmMax={this.handleSizeQmMax}
          handleSizeQmMin={this.handleSizeQmMin}
          handleSource={this.handleSource}
          handleSubmit={this.handleSubmit}
          {...this.props}
        />
      )
    }
  }

  return Container
}
